import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./assets/css/App.css";
import HealthCheck from "./pages/HealthCheck";
import LandingPage from "./pages/LandingPage";
import FirstForm from "./paymentLink/pages/FirstForm";
import PaymentLinkExpired from "./paymentLink/pages/PaymentLinkExpired";
import PaymentSuccess from "./paymentLink/pages/PaymentSuccess";
import SecondForm from "./paymentLink/pages/SecondForm";
import ThirdForm from "./paymentLink/pages/ThirdForm";
import OvoWaitingPage from "./paymentLink/pages/OvoWaitingPage";

// Payment Linking imports
import PaymentInformation from "./paymentLinking/pages/PaymentInformation";
import PaymentMethodSelection from "./paymentLinking/pages/PaymentMethodSelection";
import PaymentResult from "./paymentLinking/pages/PaymentResult";
import PaymentLinkingTest from "./paymentLinking/pages/PaymentLinkingTest";
import GoPayLinking from "./paymentLinking/pages/GoPayLinking";

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Halaman utama */}
        <Route path="/b2b/:reffNo" element={<FirstForm />} />
        <Route path="/method/:reffno" element={<SecondForm />} />
        <Route path="/instruction/:reffNo?" element={<ThirdForm />} />
        <Route path="/ovo-waiting/:reffNo" element={<OvoWaitingPage />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-expired" element={<PaymentLinkExpired />} />
        {/* <Route path="/tes-firebase" element={<FCMTokenPage />} /> */}

        {/* Payment Linking Routes */}
        <Route path="/b2b/linking/test" element={<PaymentLinkingTest />} />
        <Route path="/b2b/linking/:linkCode" element={<PaymentInformation />} />
        <Route path="/b2b/linking/:linkCode/payment-method" element={<PaymentMethodSelection />} />
        <Route path="/b2b/linking/:linkCode/gopay" element={<GoPayLinking />} />
        <Route path="/b2b/linking/:linkCode/result" element={<PaymentResult />} />

        <Route path="/health" element={<HealthCheck />} />

        {/* Halaman landing default */}
        <Route path="/" element={<LandingPage />} />

        {/* Rute tidak ditemukan */}
        <Route path="*" element={<h1>404 - Page Not Found</h1>} />
      </Routes>
    </Router>
  );
};

// function mainPage(){
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   )
// }

export default App;